export default __webpack_public_path__ + "static/blog-featured-image-87ab6850415a6e769caeb10eb6f593ae.jpg";